import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AboutUs() {
  return (
    <>
        <Nav />
        <Header />
        <section class="wrapper inner-banner-wrapper testimonial-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2>About Us</h2>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper custom-wrapper">
          <div class="container text-300">
            <div class="row">
              <div class="col-sm-12">
                <h3>It's always about ​YOU @ Techno Web Solutions!​</h3>
                <p>Knowing and understanding a customer's unique ​and exact requirements ​   and being able to fulfill​​    them not just to their satisfaction but also often beyond expectation is the hallmark of a customer​ ​<br />
                  centric organisation. At ​t​ws.twsserver.com, we are committed to achieving and exceeding this level of performance at all times. We are ​Soulfully ​devoted to providing the most reliable and highest-quality of products and services in the realm of IT services – from domain registration and web hosting to web site design and web-based software development, backed by unmatched customer support and service.</p>
                <p>In short, we are a one-stop web solutions company,​ which deliver best quality 24X7.​</p>
                <h3>End-to-end web solutions: Domain registration, web hosting, web development​, ​Web Designing, SEO/SMO ,Application development, Software development, Support.​</h3>
                <p>Established in ​April​ ​2004​ and headquartered in​ Kolkata​, technowebsol.com​ ​offers high quality and professional IT solutions and services to meet the evolving needs of businesses across the globe.</p>
                <p>We deliver innovative web solutions to clients by helping them identify their most important business and technology opportunities and capitalizing on them. We also provide solutions to help them overcome their most complex and critical challenges</p>
                <h3>Our Mission</h3>
                <p>​Our mission is ​to provide the most attractive and functional websites to our customers, helping them grow their business to a next higher level. We believe in building long term relations and so would keep our work wonderful with quality and time.</p>
                <h3>Our Vision</h3>
                <p>​Our Vision is ​to strive enthusiastically to delight our customers who are our very purpose, by pursuing brilliance and innovation through dedicated team work. To this end we shall promote continuous learning, success orientation and ethical business practices, which will make us, stand out as a global technology player.</p>
              </div>
            </div>
          </div>
        </section>
        <Footer />
    </>
  )
}

export default AboutUs